<template>
  <div>
    <ShareNeedsIllustration class="mx-auto" />
    <h3 v-if="!isPopupMode" class="font-medium text-m1 mr-24 mt-16">{{ titleForBasicUsers }}</h3>
    <CheckmarkList :tips="recruitSitterTipsForBasicUsers" />
    <Button
      value="Create A Job"
      variant="primary"
      size="medium"
      class="w-full mt-24"
      :href="`/job-post?jobPostReturnPath=${jobPostReturnPath}`"
    />
    <Button
      :value="upgradeMessage"
      variant="outlined"
      size="medium"
      class="w-full mt-24"
      to="/upgrade/pricing?source=recruit-sitter"
    />
  </div>
</template>

<script lang="ts">
import Button from '@/components/button/Button.vue';
import CheckmarkList from '@/components/checkmark_list/CheckmarkList.vue';
import ShareNeedsIllustration from '@/graphics/illustrations/ShareNeedsIllustration.vue';

export default {
  name: 'RecruitBasicNoJobs',
  components: {
    Button,
    CheckmarkList,
    ShareNeedsIllustration,
  },
  props: {
    recruitSitterTipsForBasicUsers: {
      required: true,
      type: Array,
    },
    titleForBasicUsers: {
      required: true,
      type: String,
    },
    upgradeMessage: {
      required: true,
      type: String,
    },
    noJobsExist: {
      type: Boolean,
      default: false,
    },
    jobPostReturnPath: {
      type: String,
      default: () => '',
    },
    isPopupMode: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
